var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myprofile_m"},[_c('div',{staticClass:"myprofile_mphoto",style:({ backgroundImage: ("url(" + (_vm.$store.getters.avatar) + ")") })}),_c('div',{staticClass:"myprofile_mname"},[_vm._v(_vm._s(_vm.profile.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }